// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 884 ? "admin" : chunkId) + "." + {"488":"5f6c27a8","555":"9599a1e1","884":"b1320f2a"}[chunkId] + ".chunk.js";
};